import axiosInstance from './axiosInstance';

export const getAllCustomers = () =>
    axiosInstance.get("/Customer/GetAllCustomers");

export const getCustomerWithSales = (customerId) =>
    axiosInstance.get(`/Customer/GetCustomerWithSales?customerId=${customerId}`);

export const createCustomer = (request) =>
    axiosInstance.post("/Customer/CreateCustomer", request);

export const updateCustomer = (request) =>
    axiosInstance.put("/Customer/UpdateCustomer", request);

// One customer's IC, and nothing else. The birthday on the customer page and in
// the customer list is read from it (utils/icBirthday.js); an empty value clears it.
// A single field rather than UpdateCustomer, which would rewrite the name, phone,
// email and address from the same request. (user 2026-10-21)
export const setCustomerIc = ({ customerId, ic }) =>
    axiosInstance.put("/Customer/SetIc", { customerId, ic });

export const bulkUpdateCustomersBySalesId = (rows) =>
    axiosInstance.post("/Customer/BulkUpdateBySalesId", rows);
